import React, { useState, useEffect } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { useParams} from "react-router-dom";
//import { getTimeseries } from '../API';
//import timeseries from './dummyjson/timeseries2.json';
import './timeseries.css';
import { getTimeseries } from '../API';
import { Table } from "antd";
import { getFullDate } from '../App';

const TimeSeries = () => {
  
  const { cropid } = useParams();

  const [timeRange, setTimeRange] = useState('');  
  const [showChart, setShowChart] = useState(false);

  const [dataNDVI,  setDataNDVI] =  useState([]);
  const [dataGNDVI, setDataGNDVI] = useState([]);  
  const [dataNDWI,  setDataNDWI] =  useState([]);   
  
  const [djNDVI,    setDJNDVI] =  useState([]);
  const [djGNDVI,   setDJGNDVI] = useState([]);
  const [djNDWI,    setDJNDWI] =  useState([]);  

  const [djPhen,    setDJPhen] =  useState([]);

  const [columns] = useState([
    {title: 'Ciclo',          dataIndex: 'ciclo',           key: 'ciclo',         },
    {title: 'sos',            dataIndex: 'sos',             key: 'sos',           render:((date)=>getFullDate(date))},
    {title: 'sos_val',        dataIndex: 'sos_val',         key: 'sos_val',       render:((num)=>num.toFixed(4))},
    {title: 'pos',            dataIndex: 'pos',             key: 'pos',           render:((date)=>getFullDate(date))},
    {title: 'pos_val',        dataIndex: 'pos_val',         key: 'pos_val',       render:((num)=>num.toFixed(4))},
    {title: 'eos',            dataIndex: 'eos',             key: 'eos',           render:((date)=>getFullDate(date))},
    {title: 'duracion_ciclo', dataIndex: 'duracion_ciclo',  key: 'duracion_ciclo',},
    {title: 'green_up',       dataIndex: 'green_up',        key: 'green_up',      },
    {title: 'senescence',     dataIndex: 'senescence',      key: 'senescence',    },
  ]);


  useEffect(() => {
    getTimeseries(cropid).then((timeseries) => {
      setDataNDVI(timeseries.ndvi);   
      setDataGNDVI(timeseries.gndvi);
      setDataNDWI(timeseries.ndwi);
      setDJPhen(timeseries.strpheno.sort(function(a, b) {return b.ciclo - a.ciclo;}));
    });

  }, [cropid]);

  const handleTimeRangeChange = (event) => {
    const timeframe = parseInt(event.target.value)
    
    if(timeframe>1){
      const fechaActual = new Date();
      const fechaResultante = new Date(fechaActual);
      fechaResultante.setDate(fechaResultante.getDate() - timeframe);
    }

    setTimeRange(timeframe);      
    let lstjsonNDVI = [];
    let lastdindex = dataNDVI.length;
    let firstindex = lastdindex - timeframe ;    
    
    if(firstindex > 0 && timeframe !== 0 ){      
      if(timeframe === 1){
        setDJNDVI(dataNDVI);  
        setDJGNDVI(dataGNDVI);
        setDJNDWI(dataNDWI);
      }else{
        
        lstjsonNDVI=dataNDVI.slice(firstindex);
        setDJNDVI(lstjsonNDVI);
        setDJGNDVI(dataGNDVI.slice(firstindex));
        setDJNDWI(dataNDWI.slice(firstindex));
      };
      setShowChart(true);
    } else {    
      setShowChart(false);
    };
  };

  const dateFormatter = date => {
    const parts = date.split('-');
    const dia = parseInt(parts[0]);
    let diaStr = parts[0];
    if(dia<10) diaStr = '0'+ parts[0];
    const mes = parseInt(parts[1]);
    let mesStr = parts[1];
    if(mes<10) mesStr = '0'+ parts[1];
    const yearstr = parts[2];      
    const fecha =  diaStr + '/'+ mesStr + '/' + yearstr;
    return fecha.substring(3,);
  };
  
  function roundTo3(num) {
    var m = Number((Math.abs(num) * 1000).toPrecision(15));
    return Math.round(m) / 1000 * Math.sign(num);
  }

  const CustomizedDot = (props) => {
    const { cx, cy, value,payload } = props;
    const ano = payload.date.substring(payload.date.length - 4);
    
    //console.log(ano)
    const dots = djPhen.map((season) => {
      //console.log(ciclo.sos)
      if((season.ciclo === parseInt(ano) )) 
      {         
        
        let promedio = roundTo3(value)
        let val_min = roundTo3(season.sos_val)
        let val_max = roundTo3(season.pos_val)        
        if((promedio === val_min ) || (promedio === val_max )){   
          console.log(season.ciclo)
          console.log(value)
          console.log(season.sos_val)
          console.log(season.pos_val)
          console.log(promedio)
          console.log(val_min)
          console.log(val_max)
          return (
              <svg >                
                  <circle cx={cx} cy={cy} fill="red" r={4} />
              </svg>
          );};
      };
    });
    return dots;
  };

  
  
  return (
    <div>
      <div className="select-container">
        <label htmlFor="timeRange"> Temporalidad : </label>
        <>&nbsp;&nbsp;</>
        <select id="timeRange" value={timeRange} onChange={handleTimeRangeChange} className="aesthetic-select">
          <option value="0">Seleccione una opción</option>
          <option value="120">Trimestre</option>
          <option value="250">Semestre</option>
          <option value="450">Año</option>
          <option value="900">2 años</option>
          <option value="1350">3 años</option>
          <option value="1">Todo</option>
        </select>
      </div>
      


      {showChart && (
        <>
        <div style={{width:'80vw',marginTop:'10px'}}>
          <h6>Marcadores fenológicos</h6>
        <Table dataSource={djPhen} columns={columns} />
        <h6>Gráficas de series de tiempo</h6>

        <LineChart width={1200} height={500} data={djNDVI} margin={{ top: 50, left:20 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" tickFormatter={dateFormatter}/>
          <YAxis  label={{ value: 'NDVI', angle: -90, position: 'insideLeft' }}/>
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="Min"  stroke="#ffc658" dot={false} />
          <Line type="monotone" dataKey="Promedio" stroke="#008080"dot={<CustomizedDot />} />
          <Line type="monotone" dataKey="Max" stroke="#82ca9d" dot={false} />     
              
        </LineChart>
      
        <LineChart width={1200} height={500} data={djGNDVI} margin={{ top: 50, left:20 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" tickFormatter={dateFormatter}/>
          <YAxis  label={{ value: 'GNDVI', angle: -90, position: 'insideLeft' }}/>
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="Min"  stroke="#ffc658" dot={false} />
          <Line type="monotone" dataKey="Promedio" stroke="#008080"dot={false} />
          <Line type="monotone" dataKey="Max" stroke="#82ca9d" dot={false} />          
        </LineChart>
      
        <LineChart width={1200} height={500} data={djNDWI} margin={{ top: 50, left:20 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" tickFormatter={dateFormatter}/>
          <YAxis  label={{ value: 'NDWI', angle: -90, position: 'insideLeft' }}/>
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="Min"  stroke="#ffc658" dot={false} />
          <Line type="monotone" dataKey="Promedio" stroke="#008080"dot={false} />
          <Line type="monotone" dataKey="Max" stroke="#82ca9d" dot={false} />          
        </LineChart>
        </div>
        </>)         
      }
    
    </div>
  );
};

export default TimeSeries;